import script from "./AmadeusView.vue?vue&type=script&setup=true&lang=js"
export * from "./AmadeusView.vue?vue&type=script&setup=true&lang=js"

import "./AmadeusView.vue?vue&type=style&index=0&id=11cc3199&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11cc3199"]])

export default __exports__